/**用户信息及令牌存储 */
import { ACCESS_TOKEN, USER } from '@/store/mutation-types'
import { setSessionStore, getSessionStore, removeSessionStore } from '@/utils/storage'
const user = {
    namespaced: true,
    state: {
        token: getSessionStore(ACCESS_TOKEN),
        userInfo: {},
        perfPlanPermission: {}
    },
    getters: {
        getToken(state) {
            return state.token
        },
        getUser: (state) => {
            return state.userInfo
        },
        getUserName: state => {
            return (state.userInfo && state.userInfo.nickname)
        },
        getPerfPlanPermission(state) {
            return state.perfPlanPermission
        }
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            setSessionStore(ACCESS_TOKEN, token)
            state.token = token
        },
        REMOVE_TOKEN: (state) => {
            state.token = null
            removeSessionStore(ACCESS_TOKEN)
        },
        SET_USER: (state, user) => {
            setSessionStore(USER, user)
            let userInfo = {};
            try {
                if (typeof user === 'string' && user) {
                    userInfo = JSON.parse(user) || {};
                } else if (typeof user === 'object' && user !== null) {
                    userInfo = { ...user };
                }
            } catch (error) {
                console.error('解析用户信息失败：', error);
                userInfo = {};
            }
            state.userInfo = userInfo;
        },
        REMOVE_USER: (state) => {
            state.userInfo = null
            removeSessionStore(USER)
        },
        Set_PerfPlanPerm: (state, perm) => {
            state.perfPlanPermission = perm
        }
    },

    actions: {
        // 登录
        // Login ({ commit, dispatch }, userInfo) {
        //   return new Promise(async (resolve, reject) => {
        //     const res = await userLogin(userInfo)
        //     console.log('res', res)
        //     if (res.data.status === 200) {
        //       commit('SET_TOKEN', res.data.data.token)
        //       commit('SET_USER', JSON.stringify(res.data.data.user))
        //     }
        //     resolve(res)
        //   })
        // },
        // Logout ({ commit, state }) {
        //   return new Promise(async resolve => {
        //     // await userLogout()
        //     commit('SET_TOKEN', '')
        //     removeSessionStore(ACCESS_TOKEN)
        //     resolve()
        //   })
        // }
    }
}

export default user
